import type { ReactNode } from 'react'

/**
 * A single "way to play" card for the landing page — a gold medallion icon
 * over a Cinzel title and a short blurb, on a dark parchment-tinted panel that
 * lifts and gilds its border on hover. Icon is any inline SVG (24–32 viewBox).
 */
export function FeatureCard({
  icon,
  title,
  text,
}: {
  icon: ReactNode
  title: string
  text: string
}) {
  return (
    <article
      className="feature-card group relative rounded-2xl border border-sand-500/20 bg-gradient-to-b from-ocean-900/80 to-[#06222b]/80 p-6 text-center
                 transition-[transform,border-color,box-shadow] duration-300 ease-out
                 hover:-translate-y-1.5 hover:border-sand-300/55 hover:shadow-[0_22px_50px_-22px_rgba(0,0,0,0.7)]
                 focus-within:border-sand-300/55"
    >
      <div className="mx-auto mb-5 grid place-items-center w-16 h-16 rounded-full border border-sand-500/40 bg-ocean-900/60 shadow-inner">
        {icon}
      </div>
      <h3 className="font-display text-lg text-sand-200">{title}</h3>
      <p className="mt-2 text-sm text-ocean-200 leading-relaxed text-pretty">{text}</p>
    </article>
  )
}
